import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import H4 from 'sushiweb/Typography/Heading/H4';
import H6 from 'sushiweb/Typography/Heading/H6';
import white from 'sushiweb/tokens/color/white';
import grey from 'sushiweb/tokens/color/grey';

// ============ ContentCard ============
const CardContainer = styled.div`
  background: ${props => props.bgColor || white};
  border-radius: 12px;
  padding: 24px;
  width: 100%;
  margin-top: 16px;
  box-shadow: ${props => (props.bgColor ? 'none' : '0px 2px 8px rgba(0, 0, 0, 0.04)')};
  border: ${props => (props.bordered ? `1px solid ${grey.z200}` : 'none')};
`;

const ContentCard = ({ children, bgColor, bordered }) => {
    return <CardContainer bgColor={bgColor} bordered={bordered}>{children}</CardContainer>;
};

ContentCard.propTypes = {
    children: PropTypes.node,
    bgColor: PropTypes.string,
    bordered: PropTypes.bool,
};

ContentCard.defaultProps = {
    children: null,
    bgColor: '',
    bordered: false,
};

// ============ ContentCard.Title ============
const CardTitle = styled(H4)`
  font-family: Lexend-400;
  margin: 0;
`;

ContentCard.Title = ({ children }) => {
    return <CardTitle>{children}</CardTitle>;
};

ContentCard.Title.propTypes = {
    children: PropTypes.node,
};

ContentCard.Title.defaultProps = {
    children: null,
};

// ============ ContentCard.Subtitle ============
const CardSubtitle = styled(H6)`
  font-family: Lexend-400;
  margin: 0;
`;

ContentCard.Subtitle = ({ children }) => {
    return <CardSubtitle>{children}</CardSubtitle>;
};

ContentCard.Subtitle.propTypes = {
    children: PropTypes.node,
};

ContentCard.Subtitle.defaultProps = {
    children: null,
};

// ============ ContentCard.Section ============
const CardSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1em;
`;

ContentCard.Section = ({ children }) => {
    return <CardSection>{children}</CardSection>;
};

ContentCard.Section.propTypes = {
    children: PropTypes.node,
};

ContentCard.Section.defaultProps = {
    children: null,
};

// ============ ContentCard.Divider ============
const CardDivider = styled.hr`
  border: none;
  border-top: 1px solid ${grey.z200};
  margin: 1.5em 0;
`;

ContentCard.Divider = () => {
    return <CardDivider />;
};

export default ContentCard;
